import { render, staticRenderFns } from "./PreliminaryListView.vue?vue&type=template&id=163efd78"
import script from "./PreliminaryListView.vue?vue&type=script&lang=js"
export * from "./PreliminaryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports